import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProjectIQWorkspace } from "models/IProjectIQWorkspace";

interface IProjectIQWorkspaceState {
  value: IProjectIQWorkspace[];
  isLoading: boolean;
}

const initialState: IProjectIQWorkspaceState = {
  value: [],
  isLoading: true,
};

const projectIqWorkspacesSlice = createSlice({
  name: "projectIqWorkspacesSlice",
  initialState,
  reducers: {
    setProjectIqWorkspaces: (
      state,
      action: PayloadAction<IProjectIQWorkspace[]>,
    ) => {
      state.value = action.payload;
      state.isLoading = false;
    },
    addProjectIqWorkspace: (
      state,
      action: PayloadAction<IProjectIQWorkspace>,
    ) => {
      state.value.push(action.payload);
    },
    updateProjectIqWorkspace: (
      state,
      action: PayloadAction<IProjectIQWorkspace>,
    ) => {
      const index = state.value.findIndex(
        (workspace) => workspace.id === action.payload.id,
      );
      if (index !== -1) {
        state.value[index] = { ...state.value[index], ...action.payload };
      }
    },
    removeProjectIqWorkspace: (state, action: PayloadAction<string>) => {
      state.value = state.value.filter(
        (workspace) => workspace.id !== action.payload,
      );
    },
    toggleWorkspacePin: (state, action: PayloadAction<string>) => {
      const workspace = state.value.find((w) => w.id === action.payload);
      if (workspace) workspace.isPinned = !workspace.isPinned;
    },
  },
});

export const {
  setProjectIqWorkspaces,
  addProjectIqWorkspace,
  updateProjectIqWorkspace,
  removeProjectIqWorkspace,
  toggleWorkspacePin,
} = projectIqWorkspacesSlice.actions;

const selectAllProjectIqWorkspaces = (state: {
  projectIqWorkspacesSlice: IProjectIQWorkspaceState;
}) => state.projectIqWorkspacesSlice.value;

export const selectAvailableProjectIqWorkspaces = createSelector(
  [selectAllProjectIqWorkspaces],
  (workspaces) => workspaces.filter((w) => !w.archived),
);

export const selectIsProjectIqWorkspacesLoading = (state: {
  projectIqWorkspacesSlice: IProjectIQWorkspaceState;
}): boolean => state.projectIqWorkspacesSlice.isLoading;

export default projectIqWorkspacesSlice.reducer;
